var _defs, _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBetterFuture(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            path\n            {\n                fill: #263c53;\n            }\n\n        "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M124.82,54.27A113,113,0,0,0,12,167.12H27a97.86,97.86,0,0,1,195.71,0h15A113,113,0,0,0,124.82,54.27Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M124.82,84.07a83.14,83.14,0,0,0-83,83.05h15a68,68,0,1,1,136.09,0h15A83.13,83.13,0,0,0,124.82,84.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M163.1,167.12h15a53.29,53.29,0,1,0-106.57,0h15a38.29,38.29,0,1,1,76.57,0Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M133.33,167.12h15a23.52,23.52,0,1,0-47,0h15a8.52,8.52,0,1,1,17,0Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBetterFuture);
export default __webpack_public_path__ + "static/media/better-future.020372c6cebf0f57714911caebb8c052.svg";
export { ForwardRef as ReactComponent };